<template>
  <HeaderPart v-if="$route.path !== '/' && $route.path !== '/thermalPrint' && $route.path !== '/print'"/>
  <router-view/>
  <FooterPart v-if="$route.path !== '/' && $route.path !== '/thermalPrint' && $route.path !== '/print'"/>
</template>

<script>
import HeaderPart from '@/components/HeaderPart.vue'
import FooterPart from '@/components/FooterPart.vue'
import router from './router';
export default {
  
  components: {
    HeaderPart,FooterPart
  }
}
</script>
<style>
tfoot td{
    height:30px;
    font-weight:800;
    font-size:larger;
    background: antiquewhite;
    
} 
     td{
        padding: 4px !important;
            font-size: medium;
        border: 1px solid grey;
    }
     th{
            background: maroon!important;
            color: white!important;
            text-align: center!important;
            border-radius: 0 !important;
            padding: 8px !important;
            font-size: medium !important;
    font-weight: 600 !important;
    }
    
    .select2-container .select2-selection--single ,.select2-selection__arrow{
        height: 35px !important;
    }
    .select2-selection__rendered{
        line-height: 35px !important;
    }
    table {
       width: -webkit-fill-available;
    }
    .ml-0{
            margin-left: 0.75rem;
    }
</style>
<style lang="scss"> 
.form-input{
  padding: 1px 15px;
  height: 2rem;
  text-transform: capitalize;
}

.form-input:focus{
  background: yellow;
}

button#saveBtn:focus {
    border: 1px solid red;
    background: red;
}
table{
  font-size: small;
}
input{
    
}
</style>
